import authReducer from "@/slices/authSlice";
import clipboardReducer from "@/slices/clipboardSlice";
import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import "./index.css";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    clipboard: clipboardReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
